import React, { useEffect, useState } from "react";
import TableContainer from "../../../Component/TableContainer";
import {
  Box,
  Button,
  Checkbox,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Switch,
  Typography,
} from "@mui/material";
import { useSearchParams,useNavigate, Link } from "react-router-dom";
import { masterAPI } from "../../Masters/dataConfig";
import { axiosPrivate } from "../../../axios/axios";
import {
  CheckCircle,
  DeleteOutline,
  EditOffOutlined,
  EditOutlined,
  ListAlt,
  RadioButtonUncheckedOutlined,
} from "@mui/icons-material";

import { color } from "../../../StyleData/Config";
import VendorReturnTransModal from "./VendorReturnTransModal";
import {useDispatch, useSelector} from "react-redux"
import FeedBack from "../../../Component/FeedBack";
import moment from "moment";
import { encode } from "../../../Component/JWT/Formatt";




import ResponsiveDialog from "../../../Component/ResponsiveDialog";
const VendorReturnTrans = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate=useNavigate()
  const actionsAllow=useSelector(state=>state.dataRed.actionsAllow)
  const dispatch=useDispatch()

  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [create, setCreate] = useState(false);
  const [mode, setMode] = useState("");
  const [editData, setEditData] = useState({});
  const [usageStatus,setUsageStatus]=useState([])
  const [vendorReturnId,setVendorReturnId]=useState("")
  const [feedBack, setFeedBack] = useState(false);
  const [confirmStatus, setConfirmStatus] = useState(false);
  const [pendingStatus, setPendingStatus] = useState(null);
  const [filterValue, setFilterValue] = useState("enableData");
  const [backUpData, setBackUpData] = useState([]);

  const [statusMenuDetail, setStatusDetail] = useState({});

  useEffect(() => {
    getData();
  }, []);

  const getData = async() => {
    setIsLoading(true);
    const link = masterAPI["vendorReturn"].getAll;
   await axiosPrivate
      .get(`${link}`)
      .then((res) => {
        res.data.result.sort((a, b) => {
          return a.code.localeCompare(b.code, undefined, {
            numeric: true,
            sensitivity: 'base'
          });
        });
        if (filterValue === "enableData") {
          const filterDataResult = res.data.result.filter(
            (fil) => fil.isActive
          );
          console.log(filterDataResult, "filterData");
          setData(filterDataResult);
          setBackUpData(res.data.result);
        } else {
          setData(res.data.result);
          setBackUpData(res.data.result);
        }
        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e, "vendorReturn");
        setIsLoading(false);
        setData([])
        setBackUpData([])
      });

      const usageLink=masterAPI["selectList"].inventoryusageStatus
     await axiosPrivate.get(`${usageLink}`).then(res=>{
      console.log(res)
        setUsageStatus(res.data)
        setIsLoading(false)
      }).catch(e=>{
        console.log(e,"error")
        setUsageStatus([])
        setIsLoading(false)
      })
  };

  const handleCheck=(e,value)=>{
    if(e.target.checked){
      setVendorReturnId(value)
    }else{
      setVendorReturnId("")
    }
  }

  const menuStatusHandle=(value)=>{
    console.log(value);
    setStatusDetail(value);
    setPendingStatus(value);
    setConfirmStatus(true);
  }

  const handleConfirmOk = () => {
    setConfirmStatus(false);
    if (pendingStatus.value === "Cancelled") {
      setFeedBack(true);
    } else {
      handleMenuSelect(pendingStatus, "");
    }
  };

  const handleMenuSelect = async(menuData,reason) => {
    setFeedBack(false);
    const putData = {
      id: vendorReturnId,
      status: menuData.value,
      reasontoCancel: reason,
    };
    console.log(putData);
    const statusLink = masterAPI["vendorReturn"].updateStatus;
   await axiosPrivate
      .put(`${statusLink}`, putData)
      .then((res) => {
        console.log(res);
        getData()
        setVendorReturnId("")
      })
      .catch((e) => {
        console.log(e, "error");
      });
  };

  const handleButtonNew = () => {
    setMode("Create");
    setCreate(true);
  };
  const handleCreateClose = () => {
    setMode("");
    setCreate(false);
    getData();
  };

  const handleEdit = (data) => {
    setEditData(data);
    setMode("Edit");
    setCreate(true);
  };

  // const handleDelete = (id) => {
  //   const deleteLink = masterAPI["vendorReturn"].delete;
  //   axiosPrivate
  //     .delete(`${deleteLink}/${id}`)
  //     .then((res) => {
  //       console.log(res.data);
  //       getData();
  //     })
  //     .catch((e) => {
  //       console.log(e, "delete vendorReturn");
  //     });
  // };

  const handleDelete = async(e, id) => {
    const enableLink = masterAPI["vendorReturn"].enable;
    const disableLink = masterAPI["vendorReturn"].disable;
    if (e.target.checked) {
     await axiosPrivate
        .put(`${enableLink}/${id}`)
        .then((res) => {
          console.log(res.data);
          getData();
        })
        .catch((e) => {
          console.log(e, "enable vendor return");
        });
    } else {
     await axiosPrivate
        .put(`${disableLink}/${id}`)
        .then((res) => {
          console.log(res.data);
          getData();
        })
        .catch((e) => {
          console.log(e, "disable vendor return");
        });
    }
  };

  const columns = [
    {
      accessor: "id",
      disableFilters: true,
      Cell: ({cell}) => {
        const isCreated = cell.row.original.status === "Created";
        return (
          <Box sx={{ width: color.checkBoxWidth }}>
            <Checkbox
              // icon={<RadioButtonUncheckedOutlined />}
              // checkedIcon={<CheckCircle />}
              disabled={!isCreated}
              checked={vendorReturnId===cell.value}
              onClick={(e)=>{handleCheck(e,cell.value)}}
            />
          </Box>
        );
      },
    },
    {
      Header:"Code",
      accessor:"code",
      Cell: ({ cell }) => {
        return (
          <Link
            to={`/vendorreturn/returnitem?id=${encode(cell.row.original.id)}`}
            onClick={()=>{
              dispatch({type:"storeDisplayListName",payload:{name:"vendorItem",data:cell.row.original}})
            }}
            style={{
              color: "#0d6efd",
              textDecorationLine: "underline",
              fontWeight: 800,
            }}
          >
            {cell.value}
          </Link>
        );
      },
    },
    {
      Header: "DO",
      accessor: "doNumber",
      // disableFilters: true,
    },

    {
      Header: "PO",
      accessor: "poNumber",
    },
    {
      Header: "Business Name",
      accessor: "businessName",
    },
    {
      Header: "Status",
      accessor: "status",
    },
    {
      Header: "Returned Date",
      accessor: "returnedDate",
       Cell:({cell})=>{
              return moment(cell.value).format("DD/MM/YYYY HH:mm:ss");
            }
    },
    // {
    //   Header: "Actions",
    //   Cell: ({ cell }) => {
    //     // console.log(cell)
    //     return (
    //       <Box sx={{ whiteSpace: "nowrap" }}>
    //         {/* <IconButton>
    //           <EditOutlined
    //             onClick={() => {
    //               handleEdit(cell.row.original);
    //             }}
    //             sx={{
    //               fontSize: color.masterEditDelButton,
    //               color: color.masterEditDelButtonColor,
    //             }}
    //           />
    //         </IconButton> */}
    //           <IconButton>
    //           <ListAlt
    //             onClick={() => {
    //              navigate(`/vendorreturn/returnitem?id=${cell.row.original.id}`)
    //             }}
    //             sx={{
    //               fontSize: color.masterEditDelButton,
    //               color: color.masterEditDelButtonColor,
    //             }}
    //           />
    //         </IconButton>
    //         {/* <IconButton
    //         disabled={!actionsAllow.delete}
    //         onClick={() => {
    //           handleDelete(cell.row.original.id);
    //         }}>
    //           <DeleteOutline
              
    //             sx={{
    //               fontSize: color.masterEditDelButton,
    //               color:actionsAllow.delete? color.masterEditDelButtonColor:"default",
    //             }}
    //           />
    //         </IconButton> */}
    //         {/* <Switch
    //           disabled={
    //             !actionsAllow.delete 
    //           }
    //           checked={cell.row.original.isActive}
    //           onChange={(e) => {
    //             handleDelete(e, cell.row.original.id);
    //           }}
    //         /> */}
    //       </Box>
    //     );
    //   },
    // },
  ];

  const handleChangeFilter = (e) => {
    if (e === "showAll") {
      setData(backUpData);
    } else {
      const filterDataResult = backUpData.filter((fil) => fil.isActive);

      setData(filterDataResult);
    }
    setFilterValue(e);
  };

  return (
    <>
      <Box>
        <Typography
          sx={{
            color: color.masterPageTitleColor,
            fontSize: color.masterPageTitleFontSize,
            fontWeight: color.masterPageTitleFontWeight,
            mb: color.masterPageTitlemd,
          }}
        >
          {masterAPI["vendorReturn"].title}
        </Typography>
      </Box>

      <TableContainer
        columns={columns}
        data={data}
        buttonNew={handleButtonNew}
        loading={isLoading}
        statusList={usageStatus}
        menuStatusHandle={menuStatusHandle}
        buttonDisable={!actionsAllow.create}
        changeStatusOption={vendorReturnId!==""}
        filterValue={filterValue}
        handleChange={handleChangeFilter}
        filterShow={true}
      />

      <ResponsiveDialog
        open={create}
        onClose={handleCreateClose}
        maxWidth={"xl"}
        children={
          <VendorReturnTransModal
            handleCloseClick={handleCreateClose}
            mode={mode}
            editData={editData}
          />
        }
      />

      <ResponsiveDialog
        open={feedBack}
        onClose={() => setFeedBack(false)}
        maxWidth={"lg"}
        children={
          <FeedBack
            handleCloseClick={(e) => handleMenuSelect(statusMenuDetail,e)}
            onCancel={() => {
              setFeedBack(false);
            }}
          />
        }
      />

      <ResponsiveDialog
        open={confirmStatus}
        onClose={() => setConfirmStatus(false)}
        maxWidth={"xs"}
        fullWidth
      >
        <DialogTitle>Confirm Status Change</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to change the status to{" "}
            <strong>{pendingStatus?.text}</strong>?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmStatus(false)} color="inherit">
            Cancel
          </Button>
          <Button onClick={handleConfirmOk} variant="contained" color="primary">
            OK
          </Button>
        </DialogActions>
      </ResponsiveDialog>
    </>
  );
};

export default VendorReturnTrans;
